import { useShop } from "../../context/ShopContext";

export default function FilterSidebar() {
  const {
    price,
    updatePrice,
    rating,
    updateRating,
  } = useShop();

  return (
    <aside className="sticky top-28 h-fit rounded-3xl bg-white p-6 shadow-sm">

      <h3 className="mb-6 text-xl font-semibold">
        Filters
      </h3>

      {/* Price */}

      <div className="mb-8">

        <h4 className="mb-4 font-medium">
          Price
        </h4>

        {["0-20", "20-50", "50+"].map((item) => (

          <label
            key={item}
            className="mb-3 flex cursor-pointer items-center gap-3"
          >

            <input
              type="radio"
              checked={price === item}
              onChange={() => updatePrice(item)}
            />

            ${item}

          </label>

        ))}

      </div>

      {/* Rating */}

      <div>

        <h4 className="mb-4 font-medium">
          Rating
        </h4>

        {[5, 4, 3].map((item) => (

          <label
            key={item}
            className="mb-3 flex cursor-pointer items-center gap-3"
          >

            <input
              type="radio"
              checked={rating === item}
              onChange={() => updateRating(item)}
            />

            {item}+ Stars

          </label>

        ))}

      </div>

    </aside>
  );
}